import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import '../../../assets/stylesheets/ClubSlide/ClubSettings.scss';
import { useParams } from "react-router-dom";
import Header from '../components/Header';
import { Form } from 'react-bootstrap';
import {useDispatch} from "react-redux";
import {requestSendMessage} from "../../../store/actionCreators/messages";

const ClubNewMessage =() => {
    const { t } = useTranslation();
    const {id: clubId} = useParams();
    const dispatch = useDispatch();
    const [formState, setFormState] = useState({
        title: '',
        content: ''
    });

    const handleChange = event => {
        event.persist();
        setFormState(formState => ({
                ...formState,
                [event.target.name]: event.target.value,
            }
        ))
    };

    const sendMessage = () => {
        dispatch(requestSendMessage({clubId, ...formState}));
    };

    return (
        <React.Fragment>
            <Header title={`notifications`} to={`/club/${clubId}/settings`}/>
            <div className={`notification`}>
                <Form.Group className={`title`}>
                    <Form.Label>
                        {t('title')}
                    </Form.Label>
                    <Form.Control
                        type="text"
                        name="title"
                        value={formState.title}
                        onChange={handleChange}
                        maxLength={20}
                        placeholder={t('titleIsLimitedToLetters')}
                    />
                </Form.Group>
                <Form.Group className={`content`}>
                    <Form.Label>
                        {t('content')}
                    </Form.Label>
                    <textarea
                        value={formState.content}
                        type="text"
                        min="2"
                        max="512"
                        name="content"
                        cols="37"
                        rows="6"
                        onChange={handleChange}
                    />
                </Form.Group>
                <p className={`valid`}>{t('notificationIsValid')}</p>
                <div className="dialogConfirmBox">
                    <button className="primary" onClick={sendMessage}>{t('button.send')}</button>
                </div>
            </div>
        </React.Fragment>
    );
};

export default ClubNewMessage;
